// if we didn't have execjs, we wouldn't need to do this (btoa would solve our problem)
import Base64 from './base64';
import { serverAjaxPromise } from './requests/request_helpers';

export const photoSizeMap = {
  small: { fit: 'inside', dimensions: [100, 100] },
  medium: { fit: 'inside', dimensions: [200, 200] },
  large: { fit: 'inside', dimensions: [500, 500] },
  larger_wide: { fit: 'cover', dimensions: [1080, 700] },
  extra_large: { fit: 'inside', dimensions: [2048, 2048] },
  icon: { fit: 'cover', dimensions: [50, 50] },
  small_square: { fit: 'cover', dimensions: [80, 80] },
  medium_square: { fit: 'cover', dimensions: [120, 120] },
  large_square: { fit: 'cover', dimensions: [160, 160] },
  small_wide: { fit: 'cover', dimensions: [160, 120] },
  large_wide: { fit: 'cover', dimensions: [800, 300] }
};

export const getPhotoUrl = (id, hash, photoSize) => {
  if (!id || !hash) {
    console.error("Invalid photo URL parameters.");
    return;
  }

  const settings = photoSizeMap[photoSize];
  const [width, height] = settings.dimensions;
  const fit = settings.fit;

  // Warning: Changing this has $$$ implications! Photos are cached on CloudFront using this Base64-encoded
  // object as the key. Cache misses go to Lambda to regenerate photos.
  const imageJson = JSON.stringify({
    bucket: 'assets.alltrails.com',
    key: `uploads/photo/image/${id}/${hash}.jpg`,
    edits: {
      toFormat: 'jpeg',
      resize: {
        width,
        height,
        fit
      },
      rotate: null, // use EXIF orientation
      // jpeg: { mozjpeg: true }, ideally, we'd be able to do this, but doesn't seem to be making a difference
      // the line below is an equivalent of mozjpeg: true
      jpeg: { trellisQuantisation: true, overshootDeringing: true, optimiseScans: true, quantisationTable: 3 }
    }
  });

  return `https://photos.alltrails.com/${Base64.encode(imageJson)}`;
};

export function getPhotoUrlsFromApi(subPath, perPage = 5, size = 'large') {
  return serverAjaxPromise({
    url: `/api/alltrails/v2/${subPath}/photos`,
    data: {
      per_page: perPage
    },
    resReducer: data => data.photos.map(photo => getPhotoUrl(photo.id, photo.photoHash, size))
  });
}
